import { Injectable, inject, signal, computed } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../auth/auth.service';
import { SubscriptionService } from './subscription.service';
import { SUPPORT_CONFIG } from '../models/support.models';

@Injectable({
  providedIn: 'root'
})
export class SupportModalService {
  private readonly authService = inject(AuthService);
  private readonly subService = inject(SubscriptionService);
  private readonly router = inject(Router);

  // Estado de visibilidade do modal
  private readonly _isOpen = signal<boolean>(false);
  readonly isOpen = this._isOpen.asReadonly();

  // Configuração estática de canais
  readonly config = SUPPORT_CONFIG;

  // Elegibilidade: Assinatura Ativa (status === 'active') E Perfil Admin
  readonly podeAcessarSuporte = computed(() => {
    return this.subService.ehAtivo() && this.authService.isAdmin();
  });

  // Identificação do plano ativo
  readonly planoAtual = computed(() => this.subService.planoAtual());
  readonly isPlanoAnual = computed(() => this.planoAtual() === 'anual');
  readonly isPlanoMensal = computed(() => this.planoAtual() === 'mensal');

  open(): void {
    if (!this.podeAcessarSuporte()) {
      return;
    }
    this._isOpen.set(true);
  }

  close(): void {
    this._isOpen.set(false);
  }

  navegarParaUpgrade(): void {
    this.close();
    this.router.navigate(['/planos']);
  }
}
